var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-start py-3"},[(
            (_vm.currentForm.id && _vm.can('api.v1.laboratories.update')) ||
            (!_vm.currentForm.id &&
                _vm.can('api.v1.laboratories.store') &&
                _vm.currentForm.id &&
                _vm.can('api.v1.collection-centres.update')) ||
            (!_vm.currentForm.id && _vm.can('api.v1.collection-centres.store'))
        )?_c('v-btn',{attrs:{"rounded":"","text":"","color":"primary"},on:{"click":_vm.cancelAction}},[_vm._v("\n        "+_vm._s(_vm.t('blood-providers::button.cancel'))+"\n    ")]):_vm._e(),_vm._v(" "),(
            (_vm.currentForm.id && _vm.can('api.v1.laboratories.update')) ||
            (!_vm.currentForm.id &&
                _vm.can('api.v1.laboratories.store') &&
                _vm.currentForm.id &&
                _vm.can('api.v1.collection-centres.update')) ||
            (!_vm.currentForm.id && _vm.can('api.v1.collection-centres.store'))
        )?_c('v-btn',{staticClass:"ml-4",attrs:{"rounded":"","color":"primary","loading":_vm.labCCFormLoading},on:{"click":function($event){return _vm.saveLabOrCC()}}},[_vm._v("\n        "+_vm._s(_vm.isAdmin ? _vm.t('blood-providers::button.submit') : _vm.t('blood-providers::button.send_save_request'))+"\n    ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }